/**
 * Permission keys the UI gates on, kept in a neutral module so the sidebar
 * (components/Layout) and the route guards (App.tsx) read the same literal
 * without Layout having to import from `pages/`.
 */

/** Awards read access — the same string research-api enforces via `x-permissions`. */
export const AWARDS_READ_PERMISSION = "staff.awards.read";

/** Awards write access — what the match-fixing calls on the list require, and a
 * strictly smaller audience than the read above: `staff.product` is granted
 * `staff.awards.read` and not this one (packages/permissions roles.json), so the
 * list has to render for a role that may not act on it. */
export const AWARDS_WRITE_PERMISSION = "staff.awards.write";

export const DATA_PRODUCTS_READ_PERMISSION = "staff.data_products.read";

export const DATA_PRODUCTS_WRITE_PERMISSION = "staff.data_products.write";

/** Research admin access — granted only to `staff.research_manager` in packages/permissions
 * roles.json (and to `staff.super_admin` through `*`), so gating on it is the frontend-side
 * equivalent of "research managers and admins": the L500 token carries permissions, not roles. */
export const RESEARCH_ADMIN_PERMISSION = "staff.research.admin";

/** Read access to the central audit event log, which the approval request and testimonial change
 * log reads from. Held by `staff.user_admin`, `staff.platform_admin` and super admins (through
 * `*`), because the entries carry the full text before and after every edit. */
export const AUDIT_READ_PERMISSION = "audit.read";

export const TESTIMONIALS_UNLINK_LAWYER_PERMISSION = "staff.testimonials.unlink_lawyer";

export const TAXONOMY_READ_PERMISSION = "taxonomy.read";
export const TAXONOMY_WRITE_PERMISSION = "taxonomy.write";
export const TAXONOMY_DELETE_PERMISSION = "taxonomy.delete";

export const POWERLIST_READ_PERMISSION = "powerlist.read";
export const POWERLIST_WRITE_PERMISSION = "powerlist.write";
export const POWERLIST_PUBLISH_PERMISSION = "powerlist.publish";
export const POWERLIST_DELETE_PERMISSION = "powerlist.delete";
